module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data !== null) ? _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('b-button', {
    attrs: {
      "to": {
        name: 'vote-item',
        params: {
          appId: this.$route.params.appId,
          save: true
        },
        query: {
          oversea: !!JSON.parse(_vm.$route.query.oversea)
        }
      },
      "size": "sm",
      "variant": "link"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.funcType))]), _vm._v(" 投票项" + _vm._s(!!JSON.parse(_vm.$route.query.oversea) ? _vm.overseaTag : '') + "\n    ")], 1), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.onSubmit,
      "reset": _vm.onReset
    }
  }, [_vm._l((_vm.customField), function(item, idx) {
    return [_c('b-form-group', {
      key: 'custom' + idx,
      attrs: {
        "label": item.text,
        "label-for": item.field
      }
    }, [(item.tag === 'input') ? _c('b-form-input', {
      attrs: {
        "id": item.field,
        "type": item.type,
        "required": ""
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : (item.tag === 'judge') ? _c('b-form-checkbox', {
      attrs: {
        "switch": "",
        "required": ""
      },
      on: {
        "click": function($event) {
          _vm.data[item.field] = !_vm.data[item.field]
        }
      },
      model: {
        value: (_vm.data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, item.field, $$v)
        },
        expression: "data[item.field]"
      }
    }) : _vm._e()], 1)]
  }), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "是否上线"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "required": ""
    },
    on: {
      "click": function($event) {
        _vm.data.online = !_vm.data.online
      }
    },
    model: {
      value: (_vm.data.online),
      callback: function($$v) {
        _vm.$set(_vm.data, "online", $$v)
      },
      expression: "data.online"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" 提交")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "outline-danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  }), _vm._v(" 复位")])], 1)], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-9bb73648!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vote/VoteItemForm.vue
// module id = JexA
// module chunks = 4